module.exports = __webpack_public_path__ + "static/media/124-vatican-city.36baa4fb.svg";